import ReactFlow, {
  Background,
  ConnectionMode,
  MarkerType,
  ReactFlowProvider,
  addEdge,
  getNodesBounds,
  updateEdge,
  useEdgesState,
  useNodesState,
  useReactFlow,
  type Edge,
  type Node,
  type Connection,
  type OnConnect,
  Viewport,
  ReactFlowInstance,
} from "reactflow";
import { useAutoLayout } from "./autoLayout";
import ToolBarMaps_ from "../../../../../componentes/easyMaps/toolbarMaps";
import ZoomFlow from "../../../../../componentes/easyMaps/ZoomFlow";
import NodeMenu_ from "../../../../../componentes/easyMaps/nodeMenu";
import { Box, lighten, Stack, useTheme } from "@mui/material";
import PositionableEdge from "../../../../../componentes/easyMaps/positionableEdge";
import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  type Dispatch,
  type MouseEvent as ReactMouseEvent,
  type SetStateAction,
} from "react";
import AlertModal from "../../../../../componentes/alertModal";
import ContextMenu from "../../../../../componentes/easyMaps/contextMenu";
import FilterElements from "../../../../../componentes/easyMaps/filterElements";
import TitleBar_ from "../../../../../componentes/easyMaps/titleBar";
import DescriptionBar_ from "../../../../../componentes/easyMaps/descriptionBar";
import RightBarEasyMaps_ from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import mapRouteSegment from "../../../../../utils/easyMaps/mapRouteSegment";
import EnlaceSideBarEasyMaps_ from "../../../../../componentes/easyMaps/enlaceSidebarEasyMaps";
import CreationSliderBarEasyMaps_ from "../../../../../componentes/easyMaps/creationSidebarEasymaps";
import api from "../../../../../services/api";
import { useOutletContext, useParams } from "react-router-dom";
import MenuMaps_ from "../../../../../componentes/easyMaps/menuMaps";
import LayerBar_ from "../../../../../componentes/easyMaps/layerBar";
import { useMapa } from "../../../../../contexts/mapaContext";
import ModalHistoryItem from "../../../../../componentes/easyMaps/historyItemModal";
import Element from "../../../../../componentes/easyMaps/elementNode";

import { network } from "../../../../../schemas/elements";
import { useMapActions } from "../../../../../contexts/mapActionsContext";

interface ReactFlowMapasProps {
  setEdgeSelected: Dispatch<
    SetStateAction<(Edge & { data: IMapConnection }) | null>
  >;
  setElementsConnected: Dispatch<SetStateAction<any[] | null>>;
  iconsElements: MapImage[];
  setOpenRightBar: Dispatch<SetStateAction<boolean>>;
  focusNodeId: string | null;
  handleCreateElement: (node: any) => void;
  handleDeleteElement: (id: string) => void;
  handleCreateLink: (...args: any) => void;
  handleDeleteLink: (id: string) => void;
  handleUpdateLink: (...args: any) => void;
  fullScreem: boolean;
  setFullScreem: (param: boolean) => void;
  title: string | undefined;
  setCoordenadasFlow?: (coords: { x: number; y: number }) => void;
  setIconsElements: Dispatch<SetStateAction<MapImage[]>>;
  edgeSelected: (Edge & { data: IMapConnection }) | null;
  coordenadasFlow: { x: number; y: number } | null;
  openRightBar: boolean;
  setFocusNodeId: Dispatch<SetStateAction<string | null>>;
  socketCliente: any;
  mapas: { nome: string; id: string; tipo: string }[];
  addMapInMaps: (map: { nome: string; id: string; tipo: string }) => void;
  produtos: any[];
  changeConnection: (...args: any) => void;
  loadinButtonEnlace: boolean;
  onImportComplete: (...args: any) => void;
  connectionMode: string;
  setConnectionMode: (mode: string) => void;
  xyZoomFromUrl: { x: number; y: number; zoom: number };
  changeElement: (...args: any) => void;
}

interface IMapConnection extends network.monitor.IConnection {
  config?: ConnectionConfig;
  entangled?: boolean;
  destinationId?: string;
  referenceId?: string;
  [key: string]: unknown;
}

const nodeTypes = {
  element: Element,
};
const edgeTypes = {
  positionableedge: PositionableEdge,
};

function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = structuredClone(value ?? ([] as unknown as T));
  }, [value]);

  return ref.current;
}

const TitleBar = TitleBar_ as any;
const ToolBarMaps = ToolBarMaps_ as any;
const NodeMenu = NodeMenu_ as any;
const RightBarEasyMaps = RightBarEasyMaps_ as any;
const EnlaceSideBarEasyMaps = EnlaceSideBarEasyMaps_ as any;
const CreationSliderBarEasyMaps = CreationSliderBarEasyMaps_ as any;
const MenuMaps = MenuMaps_ as any;
const LayerBar = LayerBar_ as any;
const DescriptionBar = DescriptionBar_ as any;

const ReactFlowMapasInner = (props: ReactFlowMapasProps) => {
  const {
    setEdgeSelected,
    setElementsConnected,
    iconsElements,
    setOpenRightBar,
    focusNodeId,
    handleCreateElement,
    handleDeleteElement,
    handleCreateLink,
    handleDeleteLink,
    handleUpdateLink,
    fullScreem,
    setFullScreem,
    title,
    setCoordenadasFlow = () => {},
    setIconsElements,
    edgeSelected,
    coordenadasFlow,
    openRightBar,
    setFocusNodeId,
    socketCliente,
    mapas,
    addMapInMaps,
    produtos,
    changeConnection,
    loadinButtonEnlace,
    onImportComplete,
    connectionMode,
    setConnectionMode,
    xyZoomFromUrl,
    changeElement,
  } = props;

  const urlValid =
    !Number.isNaN(xyZoomFromUrl.x) &&
    !Number.isNaN(xyZoomFromUrl.y) &&
    !Number.isNaN(xyZoomFromUrl.zoom);

  const initialViewport = useMemo(
    () =>
      urlValid
        ? { x: xyZoomFromUrl.x, y: xyZoomFromUrl.y, zoom: xyZoomFromUrl.zoom }
        : undefined,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const moveTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const updateUrl = (viewport: { x: number; y: number; zoom: number }) => {
    if (moveTimeout.current) clearTimeout(moveTimeout.current);
    moveTimeout.current = setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set("x", String(viewport.x));
      url.searchParams.set("y", String(viewport.y));
      url.searchParams.set("zoom", String(viewport.zoom));
      window.history.replaceState({}, "", url);
    }, 200);
  };

  const {
    mapId,
    elements,
    setElements,
    connections,
    setConnections,
    connectionsDataMap,
    elementSelected,
    setElementSelected,
    connectionSelected,
    setConnectionSelected,
    editMode,
    configElementDataMap,
    setEditMode,
    checkChanges,
    setCheckChanges,
    setSnackbar,
    updateDataElementSocket,
    configurationMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
    alertsDataMap,
  } = useMapa();

  const [nodes, setNodes, onNodesChange] = useNodesState<MapElement>([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState<IMapConnection>([]);
  const bounds = getNodesBounds(nodes.filter((node) => !!node?.id));
  const [lockMode, setLockMode] = useState<boolean>(false);
  const [showLabel, setShowLabel] = useState<boolean>(true);
  const [openAlertModal, setOpenAlertModal] = useState<AlertModalState>({
    open: false,
  });
  const [contextMenu, setContextMenu] = useState<{
    id: string;
    top: number;
    left: number;
  } | null>(null);
  const [contextMenuFlow, setContextMenuFlow] = useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const [elementsFilter, setElementsFilter] = useState<
    { nome: string; tipo: number }[]
  >([]);
  const [openConnection, setOpenConnection] = useState<string | null>(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState<boolean>(true);
  const [openEnlaceBar, setOpenEnlaceBar] = useState<boolean>(false);
  const [openHistoryModal, setOpenHistoryModal] = useState<boolean>(false);
  const [connectionLocal, setConnectionLocal] = useState<IMapConnection | null>(
    null,
  );
  const { fitView } = useReactFlow();

  const {
    preLayoutSnapshot,
    setPreLayoutSnapshot,
    layoutPositionsRef,
    layoutEdgesRef,
    handleAutoLayout,
    handleRevertLayout,
  } = useAutoLayout(nodes, edges, setNodes, setEdges, fitView, setCheckChanges);

  const [loadingSaveLayout, setLoadingSaveLayout] = useState<boolean>(false);

  const handleSaveAutoLayout = async () => {
    if (layoutPositionsRef.current.size === 0) return;
    try {
      setLoadingSaveLayout(true);
      const elementsData = Array.from(layoutPositionsRef.current.entries())
        .map(([elId, position]) => {
          const element = elements.get(elId);
          if (!element) return null;
          const elementConnections = Array.from(connections.values())
            .filter(
              (conn: any) =>
                conn.referenceId === elId &&
                layoutEdgesRef.current.has(conn.id),
            )
            .map((conn: any) => {
              const override = layoutEdgesRef.current.get(conn.id)!;
              return {
                id: conn.id,
                destinationId: conn.destinationId,
                item: conn.item,
                positionHandlers: override.positionHandlers ?? [],
                config: {
                  ...conn.config,
                  sourceHandle:
                    override.sourceHandle ?? conn.config?.sourceHandle,
                  targetHandle:
                    override.targetHandle ?? conn.config?.targetHandle,
                  type: override.lineType,
                  // posição da caixa (fração da linha) calculada pelo layout
                  labelT: override.labelT,
                },
              };
            });
          return {
            id: elId,
            titulo: (element as any).titulo,
            tipo: (element as any).tipo,
            font: (element as any).font,
            mapRefId: (element as any).mapRefId,
            img: (element as any).img,
            configuracao: {
              ...((element as any).elementConfig?.config ?? {}),
              coordenadas: { long: position.x, lat: position.y },
            },
            connections: { updates: elementConnections, deletes: [] },
          };
        })
        .filter(Boolean);

      if (elementsData.length === 0) return;

      const response = await api.put("/easyMaps/updateManyElements", {
        elementsData,
      });

      if (response.data) {
        response.data.forEach(
          ({
            element,
            updatedLinks,
          }: {
            element: any;
            updatedLinks: any[];
          }) => {
            setElements((prev) => {
              const next = new Map(prev);
              next.set(element.id, element);
              return next;
            });
            updatedLinks?.forEach((link: any) => {
              setConnections((prev) => {
                const next = new Map(prev);
                next.set(link.id, link);
                return next;
              });
            });
          },
        );
        layoutPositionsRef.current = new Map();
        layoutEdgesRef.current = new Map();
        setPreLayoutSnapshot(null);
        setCheckChanges(false);
        setSnackbar({
          children: "Layout salvo com sucesso!",
          severity: "success",
        });
      }
    } catch (error: any) {
      setSnackbar({
        children: `Erro ao salvar layout: ${error?.message || "Erro de comunicação"}`,
        severity: "error",
      });
    } finally {
      setLoadingSaveLayout(false);
    }
  };

  const [hostParamModal, setHostParamModal] = useState<string>("");
  const previousHandlers = usePrevious<
    { x: number; y: number; active: number }[] | undefined
  >(edgeSelected?.data?.positionHandlers);
  const previousConnection = usePrevious<string | undefined>(edgeSelected?.id);

  const elementsFromMap = useMemo<MapElement[]>(
    () => Array.from(elements.values()),
    [elements],
  );

  const connectionsFromMap = useMemo<IMapConnection[]>(
    () => Array.from(connections.values()),
    [connections],
  );

  const ref = useRef<HTMLDivElement>(null);
  const creationRef = useRef<{ create: () => void; update: () => void }>(null);
  const enlaceBarRef = useRef<{ create: () => void; update: () => void }>(null);
  const { id } = useParams<{ id: string }>();
  const { configLayer } = useOutletContext<EasyMapsLayoutContext>();
  const { setMenuConfig } = useMapActions() as any;
  const theme = useTheme();
  const modeDark = theme.palette.mode === "dark";

  useEffect(() => {
    const style = document.createElement("style");
    const enlaces = (theme.palette as any).enlaces;
    style.innerHTML = `
    @keyframes edgePulse {
      0% { stroke: ${enlaces?.offline?.main}; }
      50% { stroke: ${enlaces?.p90?.main}; }
      100% { stroke: ${enlaces?.offline?.main}; }
    }
    .edge-pulse {
      animation: edgePulse 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    }
    @keyframes dashdrawEnlace {
      from { stroke-dashoffset: var(--dash-period, 10); }
      to { stroke-dashoffset: 0; }
    }
  `;
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [theme]);

  useEffect(() => {
    setMenuConfig({
      mapId,
      title,
      produtos,
      setSnackbar,
      onImportComplete,
      exportImport: true,
      isPing: false,
      updateDataElementSocket,
    });
    return () => setMenuConfig(null);
  }, [mapId, title, produtos]);

  const styles = {
    stackContainer: {
      position: fullScreem ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: fullScreem ? "100vw" : "100%",
      height: fullScreem ? "100vh" : "100%",
      zIndex: fullScreem ? 1202 : 0,
      background:
        theme.palette.mode == "dark"
          ? theme.palette.background.default
          : lighten(theme.palette.background.default, 0.6),
      overflow: "visible",
    },
  } as const;

  const filteredData = useMemo<{
    nodes: MapElement[];
    edges: IMapConnection[];
  }>(() => {
    if (!configurationMap || !configLayer || editMode) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }
    const isPotencia = configLayer?.[String(mapId)] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    const enlacesSelected = new Set<string>(
      filtros.flatMap((label: string) => dataMap.get(label) || []),
    );

    const enlacesFiltered = connectionsFromMap.filter((conn) =>
      enlacesSelected.has(conn.id),
    );

    const markersSelectedId = new Set<string>(
      connectionsFromMap.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId ?? "", conn.referenceId ?? ""]
          : [],
      ),
    );

    const filtered = elementsFromMap.filter((m) => markersSelectedId.has(m.id));

    return { nodes: filtered, edges: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    mapId,
    elementsFromMap,
    connectionsFromMap,
    editMode,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  useEffect(() => {
    setCoordenadasFlow({
      x: bounds.x + bounds.width / 2,
      y: bounds.y + bounds.height / 2,
    });
  }, [nodes]);

  useEffect(() => {
    setContextMenu(null);
    setContextMenuFlow(null);
    setPreLayoutSnapshot(null);
    layoutPositionsRef.current = new Map();
    layoutEdgesRef.current = new Map();

    setElementsConnected(null);
    setNodes(
      handleFormaterNodes(
        structuredClone(filteredData?.nodes),
        editMode,
        showLabel,
        connectionMode,
      ),
    );
    setEdges(
      handleFormaterEdges(
        structuredClone(filteredData?.edges),
        editMode,
        showLabel,
      ),
    );
  }, [
    configLayer,
    editMode,
    showLabel,
    showLabelEnlace,
    elementsFilter,
    configurationMap,
    filteredData,
    connectionMode,
  ]);

  function handleReload() {
    setNodes(
      handleFormaterNodes(
        structuredClone(filteredData?.nodes),
        editMode,
        showLabel,
        connectionMode,
      ),
    );
    setEdges(
      handleFormaterEdges(
        structuredClone(filteredData?.edges),
        editMode,
        showLabel,
      ),
    );
  }

  useEffect(() => {
    if (!filteredData?.nodes && !filteredData?.edges) return;

    let formaterElements: MapElement[] = structuredClone(filteredData?.nodes);
    if (elementSelected) {
      formaterElements = [
        ...filteredData.nodes.filter((ele) => ele?.id !== elementSelected?.id),
        elementSelected,
      ];
    }
    let formaterConnections: IMapConnection[] = structuredClone(
      filteredData?.edges,
    );
    if (connectionSelected) {
      formaterConnections = [
        ...filteredData.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id,
        ),
        {
          ...connectionSelected,
          positionHandlers:
            edges.find((e) => e.id === connectionSelected?.id)?.data
              ?.positionHandlers ?? edgeSelected?.data?.positionHandlers,
        },
      ];
    }
    setNodes(
      handleFormaterNodes(
        formaterElements,
        editMode,
        showLabel,
        connectionMode,
      ),
    );
    setEdges(handleFormaterEdges(formaterConnections, editMode, showLabel));
  }, [filteredData, filteredData?.edges, connectionsDataMap]);

  useEffect(() => {
    if (!edgeSelected?.id) return;
    const live = edges.find((e) => e.id === edgeSelected.id);
    if (!live) return;
    if (live.data?.positionHandlers !== edgeSelected.data?.positionHandlers) {
      setEdgeSelected((prev: any) =>
        prev
          ? {
              ...prev,
              data: {
                ...prev.data,
                positionHandlers: live.data?.positionHandlers,
              },
            }
          : prev,
      );
    }
  }, [edges]);

  function updateElements() {
    setNodes((nds) => {
      let changed = false;
      const next = nds.map((n) => {
        if (elementSelected && n.id === elementSelected.id) {
          const built = handleFormaterNodes(
            [elementSelected],
            editMode,
            showLabel,
            connectionMode,
          )[0];
          if (!built) return n;
          changed = true;
          return built;
        }
        if (!n.selected && !n.draggable) return n;
        changed = true;
        return { ...n, selected: false, draggable: false };
      });
      return changed ? next : nds;
    });
  }

  function updateConnection() {
    setEdges((eds) => {
      let changed = false;
      const next = eds.map((e) => {
        if (connectionSelected && e.id === connectionSelected.id) {
          const built = handleFormaterEdges(
            [
              {
                ...connectionSelected,
                positionHandlers: edgeSelected?.data?.positionHandlers,
              },
            ],
            editMode,
            showLabel,
          )[0];
          if (!built) return e;
          changed = true;
          return built;
        }
        if (!e.selected) return e;
        changed = true;
        return { ...e, selected: false };
      });
      return changed ? next : eds;
    });
  }

  useEffect(() => {
    updateElements();
  }, [elementSelected]);

  useEffect(() => {
    updateConnection();
  }, [connectionSelected]);

  const handleFormaterNodes = (
    elementsArr: MapElement[],
    editModeArg: boolean = false,
    showLabelArg: boolean = true,
    connectionModeArg: string = "selection",
    entangled: boolean = true,
  ): Node[] => {
    const filter = elementsFilter.map((value) => value.tipo);
    const newElements =
      elementsFilter.length > 0
        ? elementsArr.filter(({ tipo }) =>
            filter.includes(tipo as unknown as number),
          )
        : elementsArr;

    const result: Node[] = newElements.map((element) => {
      const {
        id: elId,
        elementConfig,
        titulo,
        alerts,
        img,
        tipo,
      } = element as MapElement & {
        img?: string;
        tipo?: number;
      };
      const rawViewType = element?.elementConfig?.config?.viewType;
      const descricao = elementConfig?.config?.descricao;

      const resolvedViewType =
        !rawViewType || rawViewType === "automatic"
          ? configurationMap?.configuracoes?.viewType || "compact"
          : rawViewType;

      const rawNodeSize = element?.elementConfig?.config?.nodeSize;
      const resolvedNodeSize =
        !rawNodeSize || Number(rawNodeSize) === 0
          ? configurationMap?.configuracoes?.nodeSize || 0
          : rawNodeSize;
      return {
        id: elId,
        type: "element",
        draggable: !!(
          elementSelected &&
          elementSelected?.id == elId &&
          editModeArg
        ),
        position: layoutPositionsRef.current.has(elId)
          ? layoutPositionsRef.current.get(elId)!
          : {
              x: parseFloat(
                String(elementConfig?.config?.coordenadas?.long ?? 0),
              ),
              y: parseFloat(
                String(elementConfig?.config?.coordenadas?.lat ?? 0),
              ),
            },
        selected: elementSelected?.id === elId,
        data: {
          configElement: configElementDataMap.get(elId),
          img:
            iconsElements?.find((icon) => icon.id == img)?.img ||
            iconsElements?.find(
              (icon) =>
                icon.nome ==
                (tipo === 0 ? "_roteador" : tipo === 1 ? "_mapa" : "_pop"),
            )?.img,

          editMode: editModeArg,
          showLabel: showLabelArg,
          connectionMode: connectionModeArg,
          entangled,
          title: titulo,
          hosts: elementConfig?.config?.hosts,
          tipoMapa: 1,
          alerts: editModeArg ? [] : alertsDataMap.get(elId) || [],
          easyMapsConfig: structuredClone(configurationMap),
          viewType: resolvedViewType,
          size: resolvedNodeSize,
          descricao: descricao,
          value: 123,
        },
      };
    });

    return result;
  };

  const handleFormaterEdges = (
    conections: IMapConnection[],
    editModeArg: boolean = false,
    showLabelArg: boolean = true,
    entangled: boolean = true,
  ): Edge[] => {
    const result: Edge[] = conections.map((connection) => {
      const {
        id: connId,
        referenceId,
        destinationId,
        positionHandlers,
        config,
      } = connection;
      const data = (connection as { data?: unknown }).data;
      const dataConn = structuredClone(connectionsDataMap.get(connId));

      const rawViewType = config?.viewType;

      const resolvedViewType =
        !rawViewType || rawViewType === "automatic"
          ? configurationMap?.configuracoes?.viewType || "compact"
          : rawViewType;

      const rawEdgeLabelSize = config?.edgeLabelSize;
      const resolvedEdgeLabelSize =
        !rawEdgeLabelSize || rawEdgeLabelSize === 0
          ? configurationMap?.configuracoes?.edgeLabelSize || 0
          : rawEdgeLabelSize;
      const edgeLayoutOverride = layoutEdgesRef.current.get(connId);
      return {
        id: connId,
        source: referenceId ?? "",
        type: "positionableedge",
        sourceHandle: edgeLayoutOverride?.sourceHandle ?? config?.sourceHandle,
        targetHandle: edgeLayoutOverride?.targetHandle ?? config?.targetHandle,
        target: destinationId ?? "",
        animated:
          !editModeArg &&
          config?.animation !== "desativada" &&
          !dataConn?.isDown,
        updatable: "target",
        markerEnd: editModeArg
          ? {
              type: MarkerType.ArrowClosed,
              color: "#5e5e5e",
            }
          : undefined,
        labelStyle: { fill: "#26721f", fontWeight: 700 },
        selected: connectionSelected?.id === connId,
        data: {
          ...(dataConn ?? {}),
          host: elements?.get(referenceId ?? "")?.titulo,
          mapId: mapId,
          itensData: data,
          editMode: editModeArg,
          showLabel: showLabelArg,
          variant: configLayer?.[String(mapId)] || "trafego",
          showLabelEnlace,
          entangled,
          lineType: edgeLayoutOverride?.lineType ?? config?.type,
          labelT: edgeLayoutOverride
            ? edgeLayoutOverride.labelT
            : (config as any)?.labelT,
          viewType: resolvedViewType,
          edgeLabelSize: resolvedEdgeLabelSize,
          capacidade: config?.capacidade,
          positionHandlers:
            edgeLayoutOverride?.positionHandlers != null
              ? edgeLayoutOverride.positionHandlers
              : structuredClone(positionHandlers ?? []),
          //perigo eminente, sob hipótese nenhuma mexa nessa linha de código!
          label: "999.99Mbps",
          animation: config?.animation,
          easyMapsConfig: structuredClone(configurationMap),
          configLine: config,
          interfaceName: config?.interfaceName,
        },
      };
    });
    return result;
  };

  const onNodeContextMenu = useCallback(
    (event: ReactMouseEvent, node: Node<MapElement>) => {
      event.preventDefault();
      if (editMode) {
        setContextMenu(
          contextMenu === null
            ? {
                id: node.id,
                top: event.clientY - 6,
                left: event.clientX + 2,
              }
            : null,
        );
      }
    },
    [setContextMenu, editMode],
  );

  const onContextMenu = useCallback(
    (event: ReactMouseEvent) => {
      event.preventDefault();
      setContextMenuFlow(
        contextMenu === null
          ? {
              mouseX: event.clientX + 2,
              mouseY: event.clientY - 6,
            }
          : null,
      );
    },
    [setContextMenuFlow, editMode],
  );

  const proceedUpdateMode = () => {
    if (elementSelected) {
      creationRef?.current?.update();
    }
    if (connectionSelected) {
      enlaceBarRef?.current?.update();
    }
    setEditMode(!editMode);
    setFullScreem(false);
  };

  const proceedUpdateElement = useCallback(
    (id: string) => {
      const selected = structuredClone(elements?.get(id));
      if (selected?.id === elementSelected?.id) {
        setElementSelected(null);
        setConnectionSelected(null);
        return;
      }
      setConnectionSelected(null);
      setConnectionLocal(null);
      setOpenConnection(null);
      setEdgeSelected(null);
      setElementSelected(selected ?? null);

      updateConnection();
    },
    [elementSelected, elements, connectionSelected],
  );

  const saveUpdateCallback = () => {
    if (elementSelected && elementSelected?.id) {
      creationRef?.current?.update();
    } else {
      creationRef?.current?.create();
    }
    if (connectionSelected) {
      enlaceBarRef?.current?.update();
    }
  };

  const cancelUpdateElement = useCallback(() => {
    if (elementSelected) {
      setElementSelected({ ...elementSelected });
    }
    setConnectionSelected(null);
    setEdgeSelected(null);
    updateElements();
    updateConnection();
  }, [elementSelected]);

  const proceedUpdateConnection = useCallback(
    (id: string) => {
      const conn = connections?.get(id);
      const edge = edges.find((e) => id === e.id) as Edge & {
        data: IMapConnection;
      };

      setEdgeSelected((edge as Edge & { data: IMapConnection }) ?? null);

      if (!editMode) {
        setOpenConnection(id);
        setElementSelected(
          structuredClone(elements?.get(conn?.referenceId ?? "")) ?? null,
        );

        setEdges((edg) => {
          let changed = false;
          const next = edg.map((e) => {
            if ((e.data as any)?.entangled === true) return e;
            changed = true;
            return {
              ...e,
              data: e.data
                ? { ...e.data, entangled: true }
                : ({ entangled: true } as IMapConnection),
            };
          });
          return changed ? next : edg;
        });
      } else {
        setElementSelected(null);
      }
      if (conn) {
        setConnectionSelected({
          ...conn,
          positionHandlers: edge?.data?.positionHandlers,
        });
        setConnectionLocal({
          ...conn,
          positionHandlers: edge?.data?.positionHandlers,
        });
      }
      updateElements();
    },
    [connectionSelected, elementSelected, edges, connections, elements],
  );

  const cancelUpdateConnection = useCallback(() => {
    if (connectionSelected) {
      setConnectionSelected({
        ...connectionSelected,
        positionHandlers: edgeSelected?.data?.positionHandlers,
      });
    }

    if (edgeSelected) {
      setEdgeSelected({ ...edgeSelected });
    }
    setElementSelected(null);
    updateElements();
    updateConnection();
  }, [connectionSelected, edgeSelected]);

  const onNodeClick = (_event: ReactMouseEvent, node: Node<MapElement>) => {
    if (editMode && checkChanges) {
      if (connectionSelected && !elementSelected) {
        setOpenAlertModal({
          id: node.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja Salvá-las?",
          callback: (id) => {
            enlaceBarRef?.current?.update();
            proceedUpdateElement(id);
          },
          callbackCancel: cancelUpdateConnection,
        });
        return;
      }
      if (
        elementSelected?.id !== node?.id &&
        elementSelected &&
        !connectionSelected
      ) {
        setOpenAlertModal({
          id: node.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja Salvá-las?",
          callback: (id) => {
            creationRef?.current?.update();
            proceedUpdateElement(id);
          },
          callbackCancel: cancelUpdateElement,
        });
        return;
      }
      return;
    }
    proceedUpdateElement(node.id);
  };

  const onEdgeClick = (_event: ReactMouseEvent, edge: Edge<any>) => {
    if (editMode && checkChanges) {
      if (
        connectionSelected?.id !== edge?.id &&
        connectionSelected &&
        !elementSelected
      ) {
        setOpenAlertModal({
          id: edge.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja salvar?",
          callback: (id) => {
            enlaceBarRef?.current?.update();
            proceedUpdateConnection(id);
          },
          callbackCancel: cancelUpdateConnection,
        });
        return;
      }
      if (elementSelected && !connectionSelected) {
        setOpenAlertModal({
          id: edge.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja salvar?",
          callback: (id) => {
            creationRef?.current?.update();
            proceedUpdateConnection(id);
          },
          callbackCancel: cancelUpdateElement,
        });
        return;
      }
    }

    if (connectionSelected?.id !== edge?.id) {
      proceedUpdateConnection(edge.id);
    } else if (!editMode) {
      setEdgeSelected(null);
      setConnectionLocal(null);
      setConnectionSelected(null);
      setElementSelected(null);
    }
  };

  const onEdgeUpdate = (
    oldEdge: Edge<IMapConnection>,
    newConnection: Connection,
  ): boolean | void => {
    if (!editMode) return false;
    setCheckChanges(true);
    if (newConnection.source === newConnection.target) {
      return false;
    }
    const selected = connections?.get(oldEdge.id);
    if (!selected) return;
    setConnectionSelected({
      ...selected,
      config: {
        ...selected.config,
        sourceHandle: newConnection.sourceHandle ?? undefined,
        targetHandle: newConnection.targetHandle ?? undefined,
      },
      destinationId: newConnection.target ?? undefined,
      referenceId: newConnection.source ?? undefined,
    });

    setEdges((els) => updateEdge(oldEdge, newConnection, els));
    setEdgeSelected((edge) => {
      if (!edge) return edge;
      return { ...edge, ...newConnection } as Edge & { data: IMapConnection };
    });
  };

  const onConnect: OnConnect = useCallback(
    (params: Connection) => {
      const newId = String(Math.random());

      const formateParams: Edge & { data: IMapConnection } = {
        id: newId,
        type: "positionableedge",
        target: params.target ?? "",
        source: params.source ?? "",
        animated: false,
        sourceHandle: params.sourceHandle ?? undefined,
        targetHandle: params.targetHandle ?? undefined,
        markerEnd: editMode
          ? {
              type: MarkerType.ArrowClosed,
              color: "#5e5e5e",
            }
          : undefined,
        data: {
          mapId,
          editMode: true,
          showLabel,
          variant: configLayer?.[mapId as string] || "trafego",
          showLabelEnlace,
          entangled: true,
          lineType: "reta",
          viewType: "compact",
          edgeLabelSize: 0,
          positionHandlers: [],
          label: "999.99Mbps",
          easyMapsConfig: structuredClone(configurationMap),
        },
      };
      const referenceElem = elements?.get(params.source ?? "");
      let hostOriginId: string | null = null;
      if (referenceElem?.tipo == 0) {
        hostOriginId =
          referenceElem?.elementConfig?.config?.hosts?.[0]?.hostid ?? null;
      }
      const acessoProdutoId =
        referenceElem?.elementConfig?.config?.produtoId ?? "";
      const newConnection: Partial<IMapConnection> = {
        id: newId,
        destinationId: params.target ?? undefined,
        referenceId: params.source ?? undefined,
        positionHandlers: [],
        config: {
          type: "reta",
          sourceHandle: params.sourceHandle ?? undefined,
          targetHandle: params.targetHandle ?? undefined,
          capacidade: "0",
          animation: "desativada",
          hostOriginId,
        },
        item: [
          {
            acessoProdutoId,
            hostOriginId,
          },
        ],
      };
      setCheckChanges(true);
      setConnectionSelected(newConnection);

      setEdgeSelected(formateParams);
      setEdges((els) => addEdge(formateParams, els));
    },
    [setEdges, elements, connections, edges],
  );

  const onPaneClick = () => {
    setContextMenu(null);
    if (editMode) {
      if (edgeSelected && connectionSelected) {
        setEdgeSelected(structuredClone({ ...edgeSelected }));
        setConnectionSelected(structuredClone({ ...connectionSelected }));
      }
      if (elementSelected) {
        setElementSelected(structuredClone({ ...elementSelected }));
      }
    } else {
      setConnectionSelected(null);
      setOpenConnection(null);
      setEdgeSelected(null);
      setConnectionLocal(null);
      setElementSelected(null);
      setConnectionSelected(null);

      setNodes((nds) => {
        let changed = false;
        const next = nds.map((n) => {
          const needsSelected = n.selected;
          const needsEntangled = n.data?.entangled !== true;
          if (!needsSelected && !needsEntangled) return n;
          changed = true;
          return {
            ...n,
            selected: false,
            data: needsEntangled ? { ...n.data, entangled: true } : n.data,
          };
        });
        return changed ? next : nds;
      });
      setEdges((eds) => {
        let changed = false;
        const next = eds.map((e) => {
          const needsSelected = e.selected;
          const needsEntangled = (e.data as any)?.entangled !== true;
          if (!needsSelected && !needsEntangled) return e;
          changed = true;
          return {
            ...e,
            selected: false,
            data: needsEntangled
              ? ({ ...e.data, entangled: true } as IMapConnection)
              : e.data,
          };
        });
        return changed ? next : eds;
      });
      setElementsConnected(null);
    }
  };

  const onNodeDragStop = (event: ReactMouseEvent, node: Node<MapElement>) => {
    if (elementSelected && elementSelected?.id === node?.id) {
      if (
        elementSelected?.elementConfig?.config?.coordenadas?.long !==
          node?.position?.x ||
        elementSelected?.elementConfig?.config?.coordenadas?.lat !==
          node?.position?.y
      ) {
        setElementSelected((el: MapElement) => ({
          ...el,
          elementConfig: {
            config: {
              ...el?.elementConfig?.config,
              coordenadas: { long: node?.position?.x, lat: node?.position?.y },
            },
          },
        }));
        setCheckChanges(true);
      }
    }
  };

  useEffect(() => {
    if (checkChanges || !editMode) return;

    if (
      (Array.isArray(previousConnection) && previousConnection.length == 0) ||
      !previousConnection ||
      previousConnection != edgeSelected?.id
    )
      return;

    if (
      JSON.stringify(previousHandlers) ==
      JSON.stringify(edgeSelected?.data?.positionHandlers)
    )
      return;

    setCheckChanges(true);
  }, [
    edges,
    edgeSelected?.data?.positionHandlers,
    edgeSelected?.data?.positionHandlers?.length,
  ]);

  const onEdgesDelete = (edge: Edge<IMapConnection>[]) => {
    if (editMode) handleDeleteLink(edge[0]?.id);
  };
  const onNodesDelete = (nodesToDelete: Node<MapElement>[]) => {
    if (editMode) handleDeleteElement(nodesToDelete[0]?.id);
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1203 }}>
        <TitleBar title={title} id={mapId} />
      </Box>
      <Stack sx={styles.stackContainer}>
        <ToolBarMaps
          editMode={editMode}
          proceedUpdateMode={proceedUpdateMode}
          setEditMode={setEditMode}
          fullScreem={fullScreem}
          setFullScreem={setFullScreem}
          showLabel={showLabel}
          setShowLabel={setShowLabel}
          lockMode={lockMode}
          setLockMode={setLockMode}
          setShowLabelEnlace={setShowLabelEnlace}
          showLabelEnlace={showLabelEnlace}
          setOpenAlertModal={setOpenAlertModal}
          checkChanges={checkChanges}
          tipo={1}
          showMode={true}
          connectionMode={connectionMode}
          setConnectionMode={setConnectionMode}
          onAutoLayout={handleAutoLayout}
          onRevertLayout={handleRevertLayout}
          hasLayoutHistory={preLayoutSnapshot !== null}
          onSaveLayout={handleSaveAutoLayout}
          loadingSaveLayout={loadingSaveLayout}
          onFocusConnection={(conn: any) =>
            fitView({
              nodes: [{ id: conn.referenceId }, { id: conn.destinationId }],
              duration: 500,
              padding: 0.6,
            })
          }
        >
          <ToolBarMaps.InputZoomTop />
        </ToolBarMaps>
        <LayerBar
          elementSelected={elementSelected}
          mapId={mapId}
          editMode={editMode}
        />
        {!editMode && (
          <DescriptionBar
            elementSelected={!!elementSelected}
            key={"descrptionbar"}
            variant="default"
            layer={configLayer?.[String(mapId)] || "trafego"}
          />
        )}
        <FilterElements
          iconsElement={iconsElements}
          elementsFilter={elementsFilter}
          setElementsFilter={setElementsFilter}
          editMode={editMode}
        />
        <ZoomFlow
          id={id}
          focusNodeId={focusNodeId}
          setFocusNodeId={setFocusNodeId}
          skipInitialFitView={urlValid}
        />
        <ReactFlow
          ref={ref}
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          snapToGrid={false}
          onEdgeUpdate={onEdgeUpdate}
          onConnect={onConnect}
          onPaneClick={onPaneClick}
          onContextMenu={onContextMenu}
          onNodeContextMenu={onNodeContextMenu}
          elementsSelectable={!lockMode}
          nodesConnectable={!lockMode && editMode}
          nodesDraggable={elementSelected != null && !lockMode && editMode}
          attributionPosition="bottom-left"
          fitView={!urlValid}
          defaultViewport={initialViewport}
          onMove={(_: any, viewport: Viewport) => updateUrl(viewport)}
          onInit={(instance: ReactFlowInstance) =>
            updateUrl(instance.getViewport())
          }
          connectionMode={ConnectionMode.Loose}
          // onNodeDoubleClick={(event: ReactMouseEvent<HTMLDivElement>) =>
          //   event.stopPropagation()
          // }
          // onEdgeDoubleClick={(event: ReactMouseEvent<HTMLDivElement>) =>
          //   event.stopPropagation()
          // }
          onNodeClick={onNodeClick}
          onNodeDragStop={onNodeDragStop}
          onEdgeContextMenu={() => {
            setEdgeSelected(
              (edges?.find((edge) => edge.id === edgeSelected?.id) as Edge & {
                data: IMapConnection;
              }) ?? null,
            );
          }}
          onEdgeClick={onEdgeClick}
          onEdgesDelete={onEdgesDelete}
          onNodesDelete={onNodesDelete}
          minZoom={0.3}
          maxZoom={3}
          proOptions={{ hideAttribution: true }}
          //e9ebee
          style={{ background: modeDark ? "#141617" : "#e9ebee" }}
        >
          <Background />
          {contextMenu && editMode && !connectionSelected && (
            <NodeMenu
              open={contextMenu !== null}
              onClose={onPaneClick}
              handleDelete={handleDeleteElement}
              handleCreate={handleCreateElement}
              {...contextMenu}
            />
          )}
        </ReactFlow>{" "}
        {editMode && (
          <MenuMaps
            setElementSelected={setElementSelected}
            iconsElement={iconsElements.filter((icon) =>
              icon?.nome?.startsWith("_"),
            )}
            setConnectionSelected={setConnectionSelected}
            checkChanges={checkChanges}
            setOpenAlertModal={setOpenAlertModal}
            saveUpdateCallback={saveUpdateCallback}
            openEnlaceBar={openEnlaceBar}
            setOpenEnlaceBar={setOpenEnlaceBar}
          />
        )}
        <RightBarEasyMaps
          mapId={mapId}
          setFocusNodeId={setFocusNodeId}
          open={openRightBar}
          setOpen={setOpenRightBar}
          setElement={setElementSelected}
          setConnections={setElementsConnected}
          iconsElement={iconsElements}
          element={!editMode && elementSelected?.id ? elementSelected : null}
          fullScreem={fullScreem}
          openConnection={openConnection}
          setOpenConnection={setOpenConnection}
          link={`/easyMaps/mapa/${mapRouteSegment(
            elementSelected?.mapRef?.tipo,
          )}/${elementSelected?.mapRefId ?? ""}`}
          setOpenHistoryModal={setOpenHistoryModal}
          connectionSelectedLocal={connectionLocal}
          setConnectionLocal={setConnectionLocal}
          setHostParamModal={setHostParamModal}
        />
        <CreationSliderBarEasyMaps
          editMode={editMode}
          handleReload={handleReload}
          fullScreem={fullScreem}
          ref={creationRef}
          setOpenAlertModal={setOpenAlertModal}
          updateDataElementSocket={updateDataElementSocket}
          checkChanges={checkChanges}
          setCheckChanges={setCheckChanges}
          iconsElement={iconsElements}
          setIconsElement={setIconsElements}
          socket={socketCliente}
          element={editMode ? elementSelected : null}
          produtos={produtos}
          api={api}
          maps={mapas}
          addMapInMaps={addMapInMaps}
          tipoMapa={1}
          coordenadasFlow={coordenadasFlow}
          setFocusNodeId={setFocusNodeId}
          deleteElementSocket={(id: string) =>
            setOpenAlertModal({
              open: true,
              id: id,
              severity: "error",
              tipo: "element",
            })
          }
          changeConnection={changeConnection}
          openEnlaceBar={openEnlaceBar}
          setOpenEnlaceBar={setOpenEnlaceBar}
          changeElement={changeElement}
        />
        {edgeSelected && (
          <EnlaceSideBarEasyMaps
            handleReload={handleReload}
            ref={enlaceBarRef}
            setOpenAlertModal={setOpenAlertModal}
            setEdgeSelected={setEdgeSelected}
            connection={editMode ? connectionSelected : null}
            setConnection={setConnectionSelected}
            edgeSelected={edgeSelected}
            api={api}
            produtos={produtos}
            iconsElement={iconsElements}
            elements={elements}
            saveConnection={
              isNaN(Number(connectionSelected?.id))
                ? handleUpdateLink
                : handleCreateLink
            }
            changeConnection={changeConnection}
            fullScreem={fullScreem}
            tipoMapa={1}
            loadingButton={loadinButtonEnlace}
            handleDelete={(id: string) =>
              setOpenAlertModal({
                open: true,
                id: id,
                severity: "error",
                tipo: "enlace",
              })
            }
          />
        )}
        <ContextMenu
          contextMenu={contextMenuFlow}
          setContextMenu={setContextMenuFlow}
          editMode={editMode}
          setEditMode={setEditMode}
        />
        <ModalHistoryItem
          openHistoryModal={openHistoryModal}
          setOpenHistoryModal={setOpenHistoryModal}
          elementSelected={elementSelected}
          enlaceSelected={connectionLocal}
          iconsElements={iconsElements}
          host={hostParamModal}
          setHostParamModal={setHostParamModal}
        />
        <AlertModal
          openModal={openAlertModal?.open ?? false}
          setOpenModal={(data: boolean) => setOpenAlertModal({ open: data })}
          buttonText={openAlertModal?.buttonText}
          buttonCancelText={openAlertModal?.buttonCancelText}
          confirmar={false}
          handleButton={() => {
            setCheckChanges(false);
            setOpenAlertModal({ open: false });
            if (openAlertModal.callback) {
              if (openAlertModal?.id === "exit-edit-mode") {
                setElementSelected(null);
                setConnectionSelected(null);
                setEdgeSelected(null);
                setConnectionLocal(null);
                setOpenConnection(null);
              }
              if (openAlertModal?.id)
                openAlertModal.callback(openAlertModal.id);
              return;
            } else {
              setElementSelected(null);
              setConnectionSelected(null);
              setEdgeSelected(null);
            }
            if (openAlertModal?.severity == "error") {
              if (openAlertModal.tipo == "enlace" && openAlertModal?.id)
                handleDeleteLink(openAlertModal.id);
              if (openAlertModal.tipo == "element" && openAlertModal?.id)
                handleDeleteElement(openAlertModal.id);
              return;
            }
          }}
          handleCancel={() => {
            if (openAlertModal?.callbackCancel) {
              openAlertModal.callbackCancel();
              return;
            }
            setOpenAlertModal({ open: false });
          }}
          severity={openAlertModal?.severity}
          singleButton={false}
          textContent={openAlertModal?.text}
        />
      </Stack>{" "}
    </>
  );
};

const ReactFlowMapas = (props: ReactFlowMapasProps) => {
  return (
    <ReactFlowProvider>
      <ReactFlowMapasInner {...props} />
    </ReactFlowProvider>
  );
};

export default ReactFlowMapas;
